import type { AlternativeRatesRate, Money } from '../types/alternative-rate-types';
import type { Currency } from '../../../prop-types/currency-types';

export const getNormalizedCurrency = (currency: Currency | Money): Currency => {
  if ('amount' in currency) {
    return {
      value: currency.amount,
      code: currency.currency,
    };
  }

  return currency;
};

// The rate on entities and the rate returned by pusher use different properties, so we need to check both
export const getAlternativeRateCost = (rate: AlternativeRatesRate): number => {
  if (!rate) {
    return 0;
  }

  if ('totalCost' in rate) {
    return rate.totalCost?.value ?? 0;
  }

  return Number(rate.totalAmount?.amount ?? 0);
};

// The rate on entities and the rate returned by pusher use different properties, so we need to check both
export const getAlternativeRateCurrencyCode = (rate: AlternativeRatesRate): string => {
  if (!rate) {
    return '';
  }

  if ('totalCost' in rate) {
    return rate.totalCost?.code ?? '';
  }

  return rate.totalAmount?.currency ?? '';
};
